export const CONTRACT_MODES = {
    EDIT: 'edit',
    CREATE: 'create'
}

export const SUMMARY_STATUSES = {
    SUCCESS: 'success',
    ERROR: 'error',
    UNCHANGED: 'unchanged'
}
